var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "resume-body custom-resume-body" }, [
    _vm._m(0),
    _c("div", { staticClass: "border" }, [
      _c(
        "div",
        { staticClass: "border-bottom" },
        [
          _vm._v(" 1.是否曾任職於本公司:"),
          typeof _vm.dlResume.WorkedInfo.HasWorkedInCompany === "boolean"
            ? [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.HasWorkedInCompany ? "是" : "否"
                    ) +
                    " "
                ),
                _c("br"),
                _vm.dlResume.WorkedInfo.HasWorkedInCompanyDesc
                  ? _c("span", [
                      _vm._v(
                        " ，說明：" +
                          _vm._s(
                            _vm.dlResume.WorkedInfo.HasWorkedInCompanyDesc
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            : [_vm._v("無")],
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "border-bottom" },
        [
          _vm._v(" 2.是否收到日月光主動邀約:"),
          typeof _vm.dlResume.WorkedInfo.IsInvited === "boolean"
            ? [
                _vm._v(
                  " " +
                    _vm._s(_vm.dlResume.WorkedInfo.IsInvited ? "是" : "否") +
                    " "
                ),
              ]
            : [_vm._v("無")],
        ],
        2
      ),
      _c(
        "div",
        [
          _vm._v(" 3.招募管道來源:"),
          _vm.dlResume.WorkedInfo.RecruitmentSource
            ? [
                _vm._v(
                  " " +
                    _vm._s(_vm.dlResume.WorkedInfo.RecruitmentSource) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescActivityShool
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescActivityOrg
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescActivityOther
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescCenterOther
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescFlyerOther
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescJobBankOther
                    ) +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescHunter
                    ) +
                    " " +
                    _vm._s(
                      _vm.dlResume.WorkedInfo.RecruitmentSourceDescOtherSource
                    ) +
                    " "
                ),
              ]
            : [_vm._v("無")],
        ],
        2
      ),
    ]),
    _vm._v(" 一、個人資料 "),
    _c("table", [
      _c("tr", [
        _c("th", { attrs: { id: "name" } }, [_vm._v("中文姓名")]),
        _c("td", [_vm._v(_vm._s(_vm.name))]),
        _c("td", [_vm._v("性別")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.Sex))]),
        _c("td", [_vm._v("應徵工作班別")]),
        _c(
          "td",
          _vm._l(_vm.dlResume.BaseInfo.WorkShiftTypes, function (item, index) {
            return _c("span", { key: index }, [
              _vm._v(" " + _vm._s(item)),
              _c("br"),
            ])
          }),
          0
        ),
        _c("td", [_vm._v("錄取後可上班時間")]),
        _c("td", [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.WorkedInfo.AvailableOnBoardDate
                  ? _vm.$common.dateFormatter(
                      _vm.dlResume.WorkedInfo.AvailableOnBoardDate
                    )
                  : "無"
              ) +
              " "
          ),
        ]),
        _c("td", { staticClass: "width_125", attrs: { rowspan: "3" } }, [
          _c("img", {
            staticStyle: {
              width: "125px",
              height: "125px",
              "object-fit": "cover",
            },
            attrs: {
              src: _vm.headPhotoBase64
                ? _vm.headPhotoBase64
                : require(`@/assets/img/head2.png`),
              alt: "",
            },
          }),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("生日")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.$common.dateFormatter(_vm.dlResume.BaseInfo.BirthDay))
          ),
        ]),
        _c("td", [_vm._v("國籍")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.Nationality))]),
        _c("td", [_vm._v("外籍在台原因")]),
        _c("td", [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.BaseInfo.ForeignerReason
                  ? _vm.dlResume.BaseInfo.ForeignerReason
                  : "無"
              ) +
              " " +
              _vm._s(
                _vm.dlResume.BaseInfo.ForeignerReasonDesc
                  ? "-" + _vm.dlResume.BaseInfo.ForeignerReasonDesc
                  : null
              ) +
              " "
          ),
        ]),
        _c("td", [_vm._v("身分證字號/護照號碼")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.IdNo))]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("個人手機")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.MobilePhone))]),
        _c("td", [_vm._v("家用電話(區域碼-號碼)")]),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.dlResume.BaseInfo.Phone ? _vm.dlResume.BaseInfo.Phone : "無"
            )
          ),
        ]),
        _c("td", [_vm._v("身高")]),
        _c("td", [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.BaseInfo.Height
                  ? _vm.dlResume.BaseInfo.Height + "cm"
                  : "無"
              ) +
              " "
          ),
        ]),
        _c("td", [_vm._v("體重")]),
        _c("td", [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.BaseInfo.Weight
                  ? _vm.dlResume.BaseInfo.Weight + "kg"
                  : "無"
              ) +
              " "
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("*Email")]),
        _c("td", { attrs: { colspan: "8" } }, [
          _vm._v(" " + _vm._s(_vm.dlResume.BaseInfo.Email) + " "),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("配合加班")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.CanOverTime ? "是" : "否")),
        ]),
        _c("td", [_vm._v("原因說明")]),
        _c("td", { attrs: { colspan: "6" } }, [
          _vm.dlResume.BaseInfo.CanOverTimeDesc
            ? _c("span", [
                _vm._v(
                  " " + _vm._s(_vm.dlResume.BaseInfo.CanOverTimeDesc) + " "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("配合輪班")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.CanShiftWork ? "是" : "否")),
        ]),
        _c("td", [_vm._v("原因說明")]),
        _c("td", { attrs: { colspan: "6" } }, [
          _vm.dlResume.BaseInfo.CanShiftWorkDesc
            ? _c("span", [
                _vm._v(
                  " " + _vm._s(_vm.dlResume.BaseInfo.CanShiftWorkDesc) + " "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否領有身心障礙手冊")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.HasDisabilityCard ? "是" : "否")),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", { attrs: { colspan: "6" } }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.BaseInfo.HasDisabilityCardDesc
                  ? _vm.dlResume.BaseInfo.HasDisabilityCardDesc
                  : null
              ) +
              " "
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("視力")]),
        _c(
          "td",
          [
            _vm.dlResume.BaseInfo.VisualAcuity
              ? [
                  _vm._v(
                    " " +
                      _vm._s(_vm.dlResume.BaseInfo.VisualAcuity) +
                      _vm._s(
                        _vm.dlResume.BaseInfo.VisualAcuityDesc
                          ? _vm.dlResume.BaseInfo.VisualAcuityDesc
                          : null
                      ) +
                      " "
                  ),
                ]
              : [_vm._v("無")],
          ],
          2
        ),
        _c("td", { attrs: { colspan: "2" } }, [
          _c("span", [
            _vm._v("左眼度數：" + _vm._s(_vm.dlResume.BaseInfo.SPHLeft)),
          ]),
          _vm._v("、"),
          _c("span", [
            _vm._v("右眼度數：" + _vm._s(_vm.dlResume.BaseInfo.SPHRight)),
          ]),
        ]),
        _c("td", [_vm._v("是否有散光")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.HasAstigmatic ? "是" : "否")),
        ]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("span", [
            _vm._v("左眼度數：" + _vm._s(_vm.dlResume.BaseInfo.CYLLeft)),
          ]),
          _vm._v("、"),
          _c("span", [
            _vm._v("右眼度數：" + _vm._s(_vm.dlResume.BaseInfo.CYLRight)),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("住處")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.ResidenceType))]),
        _c("td", [_vm._v("出勤方式")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.CommutingType))]),
        _c("td", [_vm._v("通勤時間")]),
        _c("td", { attrs: { colspan: "4" } }, [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.CommutingMinutes)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("*通訊地址")]),
        _c("td", { attrs: { colspan: "8" } }, [
          _vm._v(
            " " +
              _vm._s(_vm.dlResume.BaseInfo.ContactCounty) +
              _vm._s(_vm.dlResume.BaseInfo.ContactDistrict) +
              " " +
              _vm._s(_vm.dlResume.BaseInfo.ContactVillage) +
              _vm._s(_vm.dlResume.BaseInfo.ContactAddress) +
              " "
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("戶籍地址")]),
        _c("td", { attrs: { colspan: "8" } }, [
          _vm._v(
            " " +
              _vm._s(_vm.dlResume.BaseInfo.County) +
              _vm._s(_vm.dlResume.BaseInfo.District) +
              " " +
              _vm._s(_vm.dlResume.BaseInfo.Village) +
              _vm._s(_vm.dlResume.BaseInfo.Address) +
              " "
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("緊急聯絡人姓名")]),
        _c("td", [_vm._v(_vm._s(_vm.dlResume.BaseInfo.EmergencyContact))]),
        _c("td", [_vm._v("緊急聯絡人關係")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.EmergencyContactRelationship)),
        ]),
        _c("td", [_vm._v("緊急聯絡人電話(手機)")]),
        _c("td", { attrs: { colspan: "4" } }, [
          _vm._v(_vm._s(_vm.dlResume.BaseInfo.EmergencyContactPhone)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("緊急聯絡人地址")]),
        _c("td", { attrs: { colspan: "8" } }, [
          _vm._v(
            " " +
              _vm._s(_vm.dlResume.BaseInfo.EmergencyContactCounty) +
              _vm._s(_vm.dlResume.BaseInfo.EmergencyContactDistrict) +
              _vm._s(_vm.dlResume.BaseInfo.EmergencyContactVillage) +
              _vm._s(_vm.dlResume.BaseInfo.EmergencyContactAddress) +
              " "
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", { attrs: { colspan: "2" } }, [
          _vm._v("目前是否在學或計劃於短期繼續升學或進修？"),
        ]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.BaseInfo.InSchoolOrHasStudyPlan ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("請詳述計畫內容")]),
        _c("td", { attrs: { colspan: "5" } }, [
          _vm._v(
            " " + _vm._s(_vm.dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc) + " "
          ),
        ]),
      ]),
    ]),
    _vm._v(" 二、工作條件 "),
    _c("table", [
      _c("tr", [
        _c("th", { attrs: { id: "question" } }, [
          _vm._v("是否可接受在無塵室穿戴無塵服及手套工作"),
        ]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.CanWorkAtCleanRoom ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.CanWorkAtCleanRoomDesc)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否可接受使用顯微鏡之工作")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.CanUseMicroscope ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.CanUseMicroscopeDesc)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否可配合單位工具及產品搬運")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.CanCarryObjects ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.CanCarryObjectsDesc)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否可接受長時間定點性/走動性久站")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.CanStandLongTime ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.CanStandLongTimeDesc)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否可接受接觸化學藥品工作")]),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.dlResume.WorkCondition.CanWorkWithChemicals ? "是" : "否"
            )
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.CanWorkWithChemicalsDesc)),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("是否可接受英文介面機台操作")]),
        _c("td", [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.WorkCondition.CanOperateMachineInEnglish
                  ? "是"
                  : "否"
              ) +
              " "
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.CanOperateMachineInEnglishDesc)
          ),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("過去兩年內是否請過長假")]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.dlResume.WorkCondition.HasLongTermVacation ? "是" : "否")
          ),
        ]),
        _c("td", [_vm._v("說明")]),
        _c("td", [
          _vm._v(_vm._s(_vm.dlResume.WorkCondition.HasLongTermVacationDesc)),
        ]),
      ]),
    ]),
    _vm._v(
      " 三、學校/學歷(填寫一項最高學歷，若尚未畢業則續填次高學歷;若為其它或國外校區，請於備註中表示校名) "
    ),
    _c(
      "table",
      [
        _vm._m(1),
        _vm._l(_vm.dlResume.Educations, function (education) {
          return _c("tr", { key: education.Id }, [
            _c("td", [_vm._v(_vm._s(education.EducationCategory))]),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    education.SchoolGuid ===
                      "11111111-1111-1111-1111-111111111111"
                      ? education.SchoolDescription
                      : education.School
                  ) +
                  " "
              ),
            ]),
            _c("td", [
              _vm._v(_vm._s(education.MajorName ? education.MajorName : "無")),
            ]),
            _c("td", [_vm._v(_vm._s(education.IsDaySchool ? "日校" : "夜校"))]),
            _c("td", [
              _vm._v(
                _vm._s(_vm.$common.monthFormatter(education.EducationFrom))
              ),
            ]),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    education.EducationTo
                      ? _vm.$common.monthFormatter(education.EducationTo)
                      : ""
                  ) +
                  " "
              ),
            ]),
            _c("td", [_vm._v(_vm._s(education.IsGraduate ? "是" : "否"))]),
          ])
        }),
        _c("tr", [
          _c(
            "td",
            { attrs: { colspan: "8" } },
            [
              _vm._v(" 目前是否在學或計畫於短期內繼續升學或進修"),
              _vm.dlResume.BaseInfo.InSchoolOrHasStudyPlan !== null
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dlResume.BaseInfo.InSchoolOrHasStudyPlan
                            ? "是"
                            : "否"
                        ) +
                        " "
                    ),
                    _vm.dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc
                      ? _c("span", [
                          _vm._v(
                            " ，說明：" +
                              _vm._s(
                                _vm.dlResume.BaseInfo.InSchoolOrHasStudyPlanDesc
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ],
      2
    ),
    _vm._v(" 四、工作/工讀經歷(請由最近工作之公司開始填起) "),
    _c(
      "table",
      [
        _vm._m(2),
        _vm._l(
          _vm.dlResume.WorkExperiences.WorkExperiences,
          function (experience, index) {
            return _c("tr", { key: experience.Id }, [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _c("td", [
                _vm._v(
                  _vm._s(experience.Seniority ? experience.Seniority : "無") +
                    "年"
                ),
              ]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$common.monthFormatter(experience.ExperienceFrom)
                    ) +
                    "~" +
                    _vm._s(
                      experience.ExperienceTo
                        ? _vm.$common.monthFormatter(experience.ExperienceTo)
                        : ""
                    )
                ),
                _c("br"),
                _vm._v(
                  " 底薪:" +
                    _vm._s(
                      experience.MonthlySalary ? experience.MonthlySalary : "無"
                    ) +
                    " "
                ),
              ]),
              _c("td", [_vm._v(_vm._s(experience.Company)), _c("br")]),
              _c("td", [_vm._v(_vm._s(experience.Department)), _c("br")]),
              _c("td", [_vm._v(" " + _vm._s(experience.Position) + " ")]),
              _c("td", [
                _vm._v(" " + _vm._s(experience.OnTheJob ? "是" : "否")),
                _c("br"),
                _vm._v(" 離職原因:" + _vm._s(experience.LeaveReason) + " "),
              ]),
            ])
          }
        ),
        _c("tr", [
          _c("td", [_vm._v("合計年資")]),
          _c("td", { attrs: { colspan: "6" } }, [
            _vm._v(_vm._s(_vm.totalSeniority) + "年"),
          ]),
        ]),
      ],
      2
    ),
    _vm._v(" 五、專業技能及認證 "),
    _c("table", [
      _c("tr", [
        _c("th", { attrs: { id: "skill" } }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.dlResume.Skill.ProfessionalSkill
                  ? _vm.dlResume.Skill.ProfessionalSkill
                  : "無"
              ) +
              " "
          ),
        ]),
      ]),
    ]),
    _vm._v(" 六、自傳 "),
    _c("table", [
      _c("tr", [
        _c("th", { attrs: { id: "question" } }, [
          _vm.dlResume.Autobiography.Autobiography
            ? _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.dlResume.Autobiography.Autobiography),
                },
              })
            : _c("span", [_vm._v("無")]),
        ]),
      ]),
    ]),
    _vm._m(3),
    _c("br"),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "border" }, [
      _vm._v(" 【個人資料蒐集、處理及利用告知事項】"),
      _c("br"),
      _vm._v(
        " 為保護台端權益，請詳閱以下告知事項，台端於下表提供個人資料並簽名即表示已理解並同意以下規定： 本公司基於招募聘用、 人事管理、業務執行及相關營運需要之目的(下合稱「特定目的」)有必要於所在地 以紙本、電子文件、電磁紀錄或其他合於當時 科學技術之適當方式，在符合個人資料保護相關法令之範圍 內，蒐集、於國內與國際間處理與利用台端於下表即未來所提供之個 人資料(下稱「個人資料」)，並得於 特定目的消失後保存至少15年。台端個人資料利用對象包括本公司及本公司國內外關係企業 (下稱「本公 司關係企業」)、本公司及本公司關係企業之職工福利委員會、財團法人日月之光慈善事業基金會、財團法 人日月光 文教基金會、以上公司、關係企業及組織之職員、代理人、專業顧問、及其所委託之第三人以及 依法令得提供其台端個人資料之 人。台端得依個人資料保護法第三條行使之相關權利包括(1)查詢或請求閱 覽(2)請求製給複製本(3)請求補充或更正(4)請求停止蒐 集、處理或利用(5)請求刪除。台端得自由選擇是 否提供相關個人資料，台端若拒絕提供相關個人資料或未確實完整填寫，本公司 可能無法進行相關審核及 處理作業而影響台端支應徵或任職機會。 "
      ),
      _c("div", { staticStyle: { "text-align": "right" } }, [
        _vm._v(" 簽名：___________________ 民國____年____月____日 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "degree" } }, [_vm._v("學位")]),
      _c("td", [_vm._v("校區/校名/備註")]),
      _c("td", [_vm._v("科系/類別")]),
      _c("td", [_vm._v("學制")]),
      _c("td", [_vm._v("入學日期(民國)")]),
      _c("td", [_vm._v("離校日期(民國)")]),
      _c("td", [_vm._v("是否畢業")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "no" } }, [_vm._v("No.")]),
      _c("td", [_vm._v("年資")]),
      _c("td", [_vm._v("工作期間(民國)/薪資")]),
      _c("td", [_vm._v("公司名稱")]),
      _c("td", [_vm._v("服務部門")]),
      _c("td", [_vm._v("職稱")]),
      _c("td", [_vm._v("在職與否/(欲)離職原因")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "border" }, [
      _vm._v(" 【聲明事項】"),
      _c("br"),
      _vm._v(
        " 1. 本人已詳閱並瞭解 貴公司依個人資料保護法及相關法令之規定所告知本履歷表內個人資料之蒐集目的、利用之期間、 地區、對象及方式、依個人資料保護法第三條規定得行使之權利及權利行使方式以及不提供本履歷表內個人資料時將對 本人權益之影響，本人於茲表示同意 貴公司依據告知內容蒐集、處理及利用本人之個人資料。 "
      ),
      _c("br"),
      _vm._v(
        " 2. 本人聲明並擔保於本履歷表內所提供第三人之個人資料，業獲該等人員同意提供其個人資料並允許相關之蒐集、處理 及利用，如有爭議發生，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。 "
      ),
      _c("br"),
      _vm._v(
        " 3. 本人確認於本履歷表內填載之各項資料與陳述均屬實，並同意 貴公司就本履歷表內所提供資料內容之正確性進行查證，如有虛偽不實之情事，本人願無條件接受 貴公司解僱處分，如涉及違法，全憑 貴公司依法處理。 "
      ),
      _c("br"),
      _vm._v(
        " 4. 本人聲明並擔保本人至 貴公司應徵未違反本人與現任雇主、前雇主或其他第三人之兼職禁止、競業禁止、利益衝突禁 止、保密協議、智慧財產權協議或其他類似之約定，前開狀態若於接獲錄取通知至 貴公司報到前有所變動，本人將主動告知並提供 貴公司所需資訊。本人並承諾確實遵守智慧財產權相關法律及本人應履行之保密或智慧財產權相關約定，應 徵期間所有之行為，絕不洩漏或侵害現任雇主、前雇主或其他第三人之營業秘密、機密資訊或其他智慧財產權。如有違 反本條，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。 "
      ),
      _c("br"),
      _vm._v(
        " 5. 本人同意如因本人未提供正確個人資料導致權益受影響或遭遇緊急事件時無法獲得迅速妥善之處理，相關後果與責任 悉由本人自行承擔。 "
      ),
      _c("br"),
      _vm._v(
        " 6. 本人同意如此次未獲 貴公司錄用或個人放棄報到， 貴公司得保留本人資料並列入儲備人員，日後若有適當職缺時得再行通知本人。 "
      ),
      _c("br"),
      _vm._v(
        " 7. 本人已詳閱「妊娠與分娩後女性及未滿十八歲勞工禁止從事危險性或有害性工作」之相關規定。 "
      ),
      _c("br"),
      _c("div", { staticStyle: { "text-align": "right" } }, [
        _vm._v(" 簽名：___________________ 民國____年____月____日 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }